// The revamp page shell — the equivalent of the design's app/layout.tsx.
// Header + page + FAQ band + footer, all inside the .vl-revamp root that the
// scoped stylesheet keys off. Used by RouteWithRevampShell in src/Pages/index.js.
//
// The stylesheet is px-based (see scripts/revamp/build-css.js), so the old
// html { font-size: 13px } from app.css can stay as it is.
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSettingData } from "../../actions/settingActions";
import { SiteHeader } from "../components/site-header";
import { SiteFooter } from "../components/site-footer";
import { FaqBand } from "../components/faq-band";
import { getOverlayRoot } from "../lib/overlay-root";

export function useRevampShellSetup() {
  const dispatch = useDispatch();

  // `setting` feeds the counters, social links and copyright (the old Footer
  // used to load it).
  useEffect(() => {
    dispatch(getSettingData());
  }, [dispatch]);

  // Overlay portal root + smooth anchor scrolling (the design set it on <html>).
  useEffect(() => {
    getOverlayRoot();
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = "smooth";
    return () => {
      document.documentElement.style.scrollBehavior = prev;
    };
  }, []);
}

export default function RevampShell({ children }) {
  useRevampShellSetup();
  return (
    <div className="vl-revamp flex min-h-screen flex-col bg-background text-foreground antialiased">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <FaqBand />
      <SiteFooter />
    </div>
  );
}
